export const readFileAsTextAsync = (file) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsText(file);
  });
};

export const readFileAsBase64Async = (file) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = () => {
      const dataUrlChunks = reader.result.split(',');

      resolve(dataUrlChunks[dataUrlChunks.length - 1]);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};

const EXTENSION_DELIMITER = '.';

export const getName = (filename) => {
  const filenameParts = filename.split(EXTENSION_DELIMITER);
  return filenameParts.length > 1
    ? filenameParts.slice(0, -1).join(EXTENSION_DELIMITER)
    : filename;
};

export const downloadDataURL = (dataURL, filename) => {
  const link = document.createElement('a');
  link.href = dataURL;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
};
